import React from "react"
import {Link} from "react-router-dom"
import {
    clearBuffer,
    contextMenuOff,
    getIdsOfPath,
    getLocalStorageItem,
    getPathBack,
    setLocalStorageItem,
    setPathBack
} from "../functions"
import {createBrowserHistory} from "history"

export class MenuCreateItemClass extends React.Component {

    render() {

        const {
            lang,
            auth,
            documents,
            clickPasteFolderHandler,
            clickPasteLinkHandler,
            clickPasteNoteHandler
        } = this.props

        const l = lang.lang
        const copyFolder = getLocalStorageItem('copyFolder')
        const copyLink = getLocalStorageItem('copyLink')
        const copyNote = getLocalStorageItem('copyNote')
        let classDNoneFolder, classDNoneLink, classDNoneNote, classDNoneClearBuffer = 'd-none'
        copyFolder ? classDNoneFolder = '' : classDNoneFolder = 'd-none'
        copyLink ? classDNoneLink = '' : classDNoneLink = 'd-none'
        copyNote ? classDNoneNote = '' : classDNoneNote = 'd-none'
        if (copyFolder || copyLink || copyNote) {
            classDNoneClearBuffer = ''
        }

        const isCutFolder = !!getLocalStorageItem('cutFolder')
        const isCutLink = !!getLocalStorageItem('cutLink')
        const isCutNote = !!getLocalStorageItem('cutNote')

        const page = getLocalStorageItem('page')
        let tree = getIdsOfPath(documents.path)
        if (page === 'FolderPage' && tree[0] === '0' && Object.keys(tree).length === 1) tree = {0: auth.rootFolder}

        if (page === 'FolderPublicPage' || page === 'FolderPage' || page === 'GoogleDrivePage') {
            return (
                <>
                    <div key={`context-menu-create-${documents.parent}`} id={"context-menu-create"}
                         className={"context-menu-create d-none"}>
                        <div className={"context-menu-body p-2"}>

                            <div>
                                {/*Сортировать*/}
                                {auth.isAuthenticated &&
                                <Link to={`/${l}/sorting-elements/${documents.parent}`}
                                      className={'item btn btn-light w-100 text-start text-black rounded-0'}
                                      rel={"noreferrer noopener"}
                                      onClick={(e) => {
                                          setPathBack(createBrowserHistory().location.pathname)
                                          contextMenuOff(e)
                                      }}>
                                    {lang.body.contextMenu.sort}
                                </Link>}
                            </div>
                            {auth.isAuthenticated && <div>
                                {/*Вставить Папку*/}
                                <Link id={"context-menu-paste-folder"}
                                      to={`/${l}/loading`}
                                      className={`item btn btn-light w-100 text-start text-black rounded-0 ${classDNoneFolder}`}
                                      onClick={() => {
                                          const copyFolderNow = getLocalStorageItem('copyFolder')
                                          const parentCut = copyFolderNow.parent
                                          clickPasteFolderHandler(copyFolderNow, documents.parent, parentCut, isCutFolder)
                                      }}>
                                    {lang.body.contextMenu.pasteFolder}
                                </Link>

                                {/*Вставить Ссылку*/}
                                <Link id={"context-menu-paste-link"}
                                      to={getLocalStorageItem('pathBack')}
                                      className={`item btn btn-light w-100 text-start text-black rounded-0 ${classDNoneLink}`}
                                      onClick={() => {
                                          const copyLinkNow = getLocalStorageItem('copyLink')
                                          const parentCut = copyLinkNow.parent
                                          clickPasteLinkHandler(copyLinkNow, documents.parent, parentCut, isCutLink).then()
                                      }}>
                                    {lang.body.contextMenu.pasteLink}
                                </Link>

                                {/*Вставить Заметку*/}
                                <Link id={"context-menu-paste-note"}
                                      to={getPathBack()}
                                      className={`item btn btn-light w-100 text-start text-black rounded-0 ${classDNoneNote}`}
                                      onClick={() => {
                                          const copyNoteNow = getLocalStorageItem('copyNote')
                                          const parentCut = copyNoteNow.parent
                                          clickPasteNoteHandler(copyNoteNow, documents.parent, parentCut, isCutNote).then()
                                      }}>
                                    {lang.body.contextMenu.pasteNote}
                                </Link>

                                {/*Создать новую папку*/}
                                <div id={"context-menu-create-folder"}
                                     className={"item btn btn-light w-100 text-start text-black rounded-0"}>
                                    <Link to={`/${lang.lang}/create-folder?folderId=${documents.parent}`}
                                          className={"text-decoration-none text-black"}>
                                        {lang.body.contextMenu.createNewFolder}
                                    </Link>
                                </div>

                                {/*Создать новую ссылку*/}
                                {page === 'FolderPage' && <div id={"context-menu-create-link"}
                                      className={"item btn btn-light w-100 text-start text-black rounded-0"}>
                                    <Link to={`/${lang.lang}/create-link?folderId=${documents.parent}`}
                                          className={"text-decoration-none text-black"}>
                                        {lang.body.contextMenu.createNewLink}
                                    </Link>
                                </div>}

                                {/*Создать новую Заметку*/}
                                {page === 'FolderPage' && <div id={"context-menu-create-note"}
                                      className={"item btn btn-light w-100 text-start text-black rounded-0"}>
                                    <Link to={`/${lang.lang}/create-note?folderId=${documents.parent}`}
                                          className={"text-decoration-none text-black"}>
                                        {lang.body.contextMenu.createNewNote}
                                    </Link>
                                </div>}

                                {/*Загрузить файл с девайса*/}
                                <div id={"context-menu-create-file"}
                                     className={"item btn btn-light w-100 text-start text-black rounded-0"}>
                                    {page === 'FolderPage' &&
                                    <Link to={`/${lang.lang}/upload-image-file?folderId=${documents.parent}`}
                                          className={"text-decoration-none text-black"}
                                          onClick={() => {
                                              setLocalStorageItem('current-folder-tree', tree)
                                          }}>
                                        {lang.body.contextMenu.uploadImages}
                                    </Link>}
                                    {page === 'GoogleDrivePage' &&
                                    <Link
                                        to={`/${lang.lang}/google-drive/upload-file`}
                                        className={"text-decoration-none text-black"}
                                        onClick={() => {
                                            setLocalStorageItem('google-drive-current-folder-tree', tree)
                                        }}>
                                        {lang.body.contextMenu.uploadFile}
                                    </Link>}
                                </div>

                                {/*Очистить буфер обмена*/}
                                <Link id={"context-menu-clear-buffer"}
                                      to={''}
                                      className={`item btn btn-light w-100 text-start text-black rounded-0 ${classDNoneClearBuffer}`}
                                      onClick={clearBuffer}>
                                    {lang.body.contextMenu.clearBuffer}
                                </Link>
                            </div>}

                            {!auth.isAuthenticated && <div>
                                <div id={"context-menu-authorization"}
                                     className={"item btn btn-light w-100 text-start text-black rounded-0"}>
                                    <Link to={`/${l}/auth-form`}
                                          className={"text-decoration-none text-black"}>
                                        {lang.body.contextMenu.auth}
                                    </Link>
                                </div>
                            </div>}
                        </div>
                    </div>
                </>
            )
        } else {
            return (
                <>
                    <div key={`context-menu-create-${documents.parent}`} id={"context-menu-create"}
                         className={"context-menu-create d-none"}>
                        <div className={"context-menu-body p-2"}>
                            {/*Авторизоваться*/}
                            {!auth.isAuthenticated && <div>
                                <div id={"context-menu-authorization"}
                                     className={"item btn btn-light w-100 text-start text-black rounded-0"}>
                                    <Link to={`/${l}/auth-form`}
                                          className={"text-decoration-none text-black"}>
                                        {lang.body.contextMenu.auth}
                                    </Link>
                                </div>
                            </div>}
                            {/*Создать новую папку*/}
                            <div id={"context-menu-create-folder"}
                                 className={"item btn btn-light w-100 text-start text-black rounded-0 d-none"}>
                                <Link to={`/${lang.lang}/create-folder?folderId=${documents.parent}`}
                                      className={"text-decoration-none text-black"}>
                                    {lang.body.contextMenu.createNewFolder}
                                </Link>
                            </div>

                            {/*Создать новую ссылку*/}
                            <div id={"context-menu-create-link"}
                                 className={"item btn btn-light w-100 text-start text-black rounded-0 d-none"}>
                                <Link to={`/${lang.lang}/create-link?folderId=${documents.parent}`}
                                      className={"text-decoration-none text-black"}>
                                    {lang.body.contextMenu.createNewLink}
                                </Link>
                            </div>

                            {/*Создать новую Заметку*/}
                            <div id={"context-menu-create-note"}
                                 className={"item btn btn-light w-100 text-start text-black rounded-0 d-none"}>
                                <Link to={`/${lang.lang}/create-note?folderId=${documents.parent}`}
                                      className={"text-decoration-none text-black"}>
                                    {lang.body.contextMenu.createNewNote}
                                </Link>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    }
}